// Pure classification shared by request and login errors, without starting Umi.
export function transportFailureKey(error: any): string {
  if (error?.response?.status) return '';
  const code = String(error?.code || '');
  const name = String(error?.name || '');
  const message = String(error?.message || '');
  if (['ECONNABORTED', 'ETIMEDOUT', 'ERR_TIMEOUT'].includes(code) || /timeout|timed out|deadline exceeded/i.test(message)) {
    return 'requestError.requestTimeout';
  }
  if (code === 'ERR_CANCELED' || name === 'CanceledError' || name === 'AbortError') return 'requestError.canceled';
  if (code === 'ERR_NETWORK' || /^(network error|failed to fetch|load failed)$/i.test(message) || /networkerror|econnreset|econnrefused|enotfound/i.test(message)) return 'requestError.network';
  if (/unexpected (token|end)|json parse|invalid json|syntaxerror/i.test(message)) return 'requestError.responseInvalid';
  return '';
}

const ACQUIRE_KEYS: Record<string, string> = {
  credit_insufficient: 'requestError.acquire.creditInsufficient',
  quota_exceeded: 'requestError.acquire.quotaExceeded',
  no_platform_key_and_no_custom_key: 'requestError.acquire.noPlatformKey',
  no_platform_key: 'requestError.acquire.noPlatformKey',
  provider_not_found: 'requestError.acquire.providerNotFound',
  provider_disabled: 'requestError.acquire.providerDisabled',
};

export function acquireFailureKey(data: any): string {
  const details = data?.error?.details;
  const explicit = typeof details === 'string' ? details : details?.reason ?? data?.reason;
  if (typeof explicit === 'string' && Object.prototype.hasOwnProperty.call(ACQUIRE_KEYS, explicit)) return ACQUIRE_KEYS[explicit];
  const messages = [typeof data === 'string' ? data : '', data?.message, data?.error?.message];
  for (const value of messages) {
    if (typeof value !== 'string') continue;
    const text = value.trim();
    if (Object.prototype.hasOwnProperty.call(ACQUIRE_KEYS, text)) return ACQUIRE_KEYS[text];
    const match = text.match(/^(?:quota blocked|acquire failed):\s*([a-z_]+)(?:$|\s|\()/i);
    if (match && Object.prototype.hasOwnProperty.call(ACQUIRE_KEYS, match[1])) return ACQUIRE_KEYS[match[1]];
  }
  return '';
}
